import { Location } from '#/graphql/types';

export default function LocationItem(data: Location) {
  return (
    <div>
      <div>{data.name}</div>
      <div>{data.buildingAddress}</div>
    </div>
  );
}
